<template>
    <div class="uk-padding uk-background-muted uk-margin-remove-top">
        <div class="uk-container">
            <div uk-grid>


                <div class="uk-width-2-5@m uk-padding" style="margin-right: -120px; z-index: 1;">
                    <div class="" style="background-color: rgb(3, 56, 96); height: 100%">
                        <div class="uk-padding">
                            <h3 class=" uk-light uk-text-left uk-text-uppercase " style="margin-top: 30px; font-variant: all-small-caps; font-family: 'Nanum Gothic', sans-serif ">Graduate Admissions</h3>
                            <hr>
                            <div class="uk-text-small uk-light">
                                Go further, be greater and take that next step. In your pursuit of excellence, let our industry leading professionals help
                                set you to fully embrace your passion and drive.

                                Shape your future today.
                            </div>
                            <br><br>
                            <router-link class="uk-align-right@m uk-light uk-text-small" style="border-bottom: 1px solid gold" to="/graduateadmission">
                                Graduate Admission
                                <span uk-icon="arrow-right"></span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="uk-width-3-5@m" style=" z-index: 0;">
                    <img src="../../assets/gadmin.jpg"  alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "graduateAdmissions"
    }
</script>

<style scoped>
    .linkColor{
        color: white;
        font-variant: all-small-caps;
        font-size: 18px;
    }
    h3{
        color: rgba(255, 215, 3,0.9);
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 500;
    }
</style>